"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.PlaybackRateMenuButtonControl = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var listbox_button_1 = require("../listbox/listbox-button");
var video_context_1 = require("../../context/video-context");
var react_1 = require("@xstate/react");
var find_1 = __importDefault(require("lodash/find"));
var selectors_1 = require("../../selectors");
var PlaybackRateMenuButtonControl = function (props) {
    var videoService = (0, video_context_1.useVideo)();
    var playbackRate = (0, react_1.useSelector)(videoService, selectors_1.selectPlaybackRate);
    var _a = props.rates, rates = _a === void 0 ? [3, 2.5, 2, 1.5, 1.25, 1, 0.5, 0.25] : _a, _b = props.selected, selected = _b === void 0 ? playbackRate : _b, onChange = props.onChange;
    var items = rates.map(function (rate) { return ({
        label: "".concat(rate, "\u00D7"),
        value: "".concat(rate)
    }); });
    var group = {
        label: 'Speed',
        items: items
    };
    var selectedItem = (0, find_1["default"])(items, { value: selected.toString() }) || items[3];
    var handleSelectItem = React.useCallback(function (index) {
        if (index >= 0 && index < rates.length) {
            videoService.send({
                type: 'PLAYBACKRATE_CHANGE',
                playbackRate: rates[index]
            });
            if (onChange) {
                onChange(rates[index]);
            }
        }
    }, [onChange, rates, videoService]);
    React.useEffect(function () {
        var selectedIndex = rates.indexOf(selected) > -1
            ? rates.indexOf(selected)
            : rates.indexOf(playbackRate) || 0;
        handleSelectItem(selectedIndex);
    }, [handleSelectItem, playbackRate, rates, selected]);
    var title = "".concat((playbackRate === null || playbackRate === void 0 ? void 0 : playbackRate.toString()) === '1' ? 'Normal' : playbackRate, " playback speed");
    return (React.createElement("div", { className: "cueplayer-react-playback-rate" },
        React.createElement(listbox_button_1.ListboxButton, { className: (0, classnames_1["default"])('cueplayer-react-playback-rate-button', props.className), selectedItem: selectedItem, onSelectItem: handleSelectItem, title: title, items: [group] },
            React.createElement("span", { className: "cueplayer-react-control-text" }, "Playback Rate"),
            React.createElement("div", { className: "cueplayer-react-playback-rate-value" }, "".concat(playbackRate.toFixed(2), "\u00D7")))));
};
exports.PlaybackRateMenuButtonControl = PlaybackRateMenuButtonControl;
